var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7648 3.02906C14.1118 5.27698 14.1118 8.91699 11.7648 11.1649C9.41781 13.4093 5.61048 13.4093 3.25977 11.1649C0.912788 8.91699 0.912788 5.27343 3.2635 3.02906C5.61048 0.781131 9.41781 0.781131 11.7648 3.02906Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2597 15.263C17.5801 15.5684 17.5801 16.0656 17.2597 16.371L17.2001 16.4278C16.8797 16.7332 16.3619 16.7332 16.0415 16.4278L11.1538 11.7509L12.3683 10.5896L17.2597 15.2666V15.263Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhite);
export default __webpack_public_path__ + "static/media/search-white.2edb5b1e985c02f8e1ef1a5a9aaa304c.svg";
export { ForwardRef as ReactComponent };